import styled from "styled-components";

export const DropdownContainer = styled.div`
  display: contents;

  #dropdown-button {
    color: inherit;
    background: inherit;
    border: 0;
    padding: 0;

    &:hover {
      background-color: transparent;
    }
  }

  .dropdown-menu {
    background: ${({ theme }) => theme.dropdown.bg.quaternary} !important;
    position: absolute;
    border: none;
    border-radius: 16px;

    .dropdown-item {
      color: ${({ theme }) => theme.global.extraInfo.font.color};
      text-align: center;
      display: flex;

      &:hover {
        color: ${({ theme }) => theme.global.color.bodyColor};
      }
      .icon {
        margin-right: 0.5rem;
      }
    }
  }

  .dropdown-toggle-split {
    border-radius: 12px !important;
    position: absolute !important;
    right: 0 !important;
  }

  .dropdown-toggle::after {
    display: none;
    &::after {
      display: inline-block;
    }
  }
  .dropdown-btn {
    text-align: start;
  }
`;

export const CustomDropdownContainer = styled.div`
  .floated-label {
    position: relative;

    label {
      position: absolute;
      top: -20px;
      left: 0px;
      padding: 0px 5px;
    }
  }
  .btn-select {
    min-width: 95px;
  }
  .popover {
    top: -5px !important;
    color: ${({ theme }) => theme.dropdown.bg.quaternary};
    border: 1px solid #ffffff;
    border-radius: 6px;

    .popover-header,
    .popover-body {
      background: #191b20;
      color: ${({ theme }) => theme.dropdown.bg.quaternary};
      border-radius: 6px;
    }

    .popover-arrow {
      display: none;
    }
  }

  .has-error {
    border: 1px solid lightcoral !important;
  }

  @media (max-width: 767px) {
    .floated-label label {
      top: -14px;
      font-size: 8px;
    }
  }
`;
